import {
  Avatar,
  Breadcrumb,
  Button,
  Col,
  ConfigProvider,
  Empty,
  FormInstance,
  Input,
  Pagination,
  Row,
  Space,
  Spin,
  Table,
  Tooltip,
  notification
} from "antd";
import React from "react";
import { connect } from "react-redux";
import { Link, NavLink, RouteComponentProps } from "react-router-dom";
import { CancelTokenSource } from "../../../axios/axios.core";
import { RootStoreModel } from "../../../redux/reducers";
import { BasicStateForListModel } from "../../models";

import { QuestionCircleOutlined } from "@ant-design/icons";
import { TagProps } from "@axios/models";
import { getOrgsOptionsSelector, treeNode } from "@redux/selector";
import {
  getTemplateAppInstallStateList,
  templateAppRetryInstall
} from "../../../axios/api.device";

import i18n from "@src/locales";
import en_US from "antd/es/locale/en_US";
import zh_CN from "antd/es/locale/zh_CN";
import { t } from "i18next";
import { Translation } from "react-i18next";

interface stateModel extends BasicStateForListModel {
  appFormRef: FormInstance<any> | null;
  isDeviceModalvisible: boolean;
  search: string;
  deviceType: string;
  syncLoding: boolean,
  isPushModalvisible: boolean,
  selectAppId: string;
  tags: any[],
  tableColumns: any[],
  templateId: string,
}

interface propsModel extends RouteComponentProps<any, any, any> {
  tokenSuccess: boolean,
  orgOptions: treeNode[],
}

const mapStatetoProps = (state: RootStoreModel) => ({
  tokenSuccess: state.userState.tokenSuccess,
  orgOptions: getOrgsOptionsSelector(state),
});

class TemplateAppInstallPage extends React.Component<propsModel, stateModel> {
  formRef = React.createRef<FormInstance>();
  constructor(props: propsModel) {
    super(props);
    this.state = {
      pageIndex: 1,
      pageSize: 10,
      totalCount: 0,
      loading: false,
      columns: [],
      data: [],
      appFormRef: React.createRef<FormInstance>().current,
      isDeviceModalvisible: false,
      search: "",
      deviceType: "",
      syncLoding: false,
      isPushModalvisible: false,
      selectAppId: "",
      tags: [],
      tableColumns: [],
      templateId: this.props.match.params.id,
    };
  }

  cancelToken = CancelTokenSource();

  componentDidMount() {
    if (this.props.tokenSuccess) {
      this.getList();
      //this.getTasks();
    }
    this.setState({
      tableColumns: [
        {
          title: '',
          dataIndex: 'iconUrl',
          key: 'iconUrl',
          align: 'center',
          render: (v:any) => (
            <Avatar
              shape="square"
              size={68}
              src={v}
              alt=""
            />
          )
        },
        {
          title: '应用名称',
          dataIndex: 'name',
          key: 'name',
        },
        {
          title: '包名',
          dataIndex: 'packageName',
          key: 'packageName',
        },
        {
          title: '类型',
          dataIndex: 'flag',
          key: 'flag',
        },
        {
          title: '平台',
          dataIndex: 'deviceFamilies',
          key: 'deviceFamilies',
          render: (v: any, row: any) => {
            return this.getDeviceFamiliesStr(row.deviceFamilies);
          }
        },
        {
          title: '安装明细',
          dataIndex: 'installCount',
          key: 'installCount',
          filterDropdown: true,
          filterIcon: (
            <Tooltip title={t("显示通过MDM成功触发安装应用指令的设备具体状态，仅支持iOS16以上并开启声明式管理的设备并且操作InstallApp成功")}>
              <QuestionCircleOutlined />
            </Tooltip>
          ),
          align: "center",
          render: (v: any, row: any) => {
            return (
              <NavLink to={{ 
                pathname: `/home/profiles/apps/installDetail`, 
                state: { 
                  "templateId": this.state.templateId,
                  "isAppStore": true,
                  "platform": this.getDeviceFamiliesStr(row.deviceFamilies), 
                  "packageName": row.packageName, 
                  "logoUrl": row.iconUrl, 
                  "name": row.name, 
                  "versionNumber": row.version, 
                  "appSize": row.displaySize
                } 
              }}>
                {`${row.installSuccessCount} / ${v}`}
              </NavLink>
            )
          }
        },
        {
          title: '操作',
          dataIndex: 'id',
          key: 'id',
          align: 'center',
          render: (v: any, row: any) => {
            return (
              <Space size={8}>
                  <Button disabled={row?.installCount - row?.installSuccessCount <= 0}
                      onClick={() => { this.rertyInstall(row); }} type="link" block>{t("失败重试")}</Button>
              </Space>
          );
          }
        },
      ]
    })
  }
  // getTasks = () => {
  //   getTagList().then((res) => {
  //     var dat = this.formatOptions(res)
  //     console.log("formatOptions", dat);
  //     this.setState({ tags: dat })
  //   })
  // }
  formatOptions = (tags: TagProps[]) => {
    return tags.map(({ id, key, values }) => {
      return {
        value: id,
        label: key,
        children: values.map((item: any) => ({
          value: item.id,
          label: item.value,
        })),
      };
    });
  }
  componentDidUpdate(prevProps: propsModel) {
    if (this.props.tokenSuccess != prevProps.tokenSuccess) {
      this.getList();
      //this.getTasks();
    }
  }

  componentWillUnmount() {

    this.cancelToken.cancel("cancel axios http request");
  }

  onSearch = () => {
    this.getList(1);
  };

  rertyInstall = (row:any) => {
    const { templateId } = this.state;
    templateAppRetryInstall(templateId,row.packageName).then(()=>{
      notification.success({ message: <Translation>{t => {return t("提交成功")}}</Translation> });
    },
    ()=>{notification.error({ message: <Translation>{t => {return t("提交失败")}}</Translation> })});
  };

  getList = (
    pageIndex = this.state.pageIndex,
    pageSize = this.state.pageSize
  ) => {
    const { templateId, search } = this.state;
    this.setState({ loading: true });
    getTemplateAppInstallStateList(templateId, {
      pageIndex,
      pageSize,
      search: search
    }).then((res) => {
      const { dataList } = res;
      this.setState({
        data: dataList.map((item, i) => ({ ...item, key: i })),
        pageSize: res.pageSize,
        pageIndex: res.pageIndex,
        loading: false,
        totalCount: res.totalCount,
      });
    });
  };
  getDeviceFamiliesStr(de: any[]) {
    var str = "";
    if (de == null) {
      return "";
    }
    for (var i = 0; i < de.length; i++) {
      if (de[i] == "iphone" || de[i] == "ipad" || de[i] == "mac") {
        str += de[i] == "iphone" ? "iPhone" : de[i] == "ipad" ? "iPad" : de[i];
        str += "/"
      }
    }
    str = str.substring(0, str.length - 1);
    return str;
  }

  render() {
    const {
      loading,
      data,
      pageSize,
      pageIndex,
      totalCount,
      search,
      tableColumns,
    } = this.state;
    // console.log(columns)
    return (
      <Translation>{t => {
        return (
          <div>
            <div className="breadcrumbTop py-2">
              <Breadcrumb>
                <Breadcrumb.Item>{t("配置文件")}</Breadcrumb.Item>
                <Breadcrumb.Item><Link to={"/home/profiles/appIndex"}>{t("应用")}</Link></Breadcrumb.Item>
                <Breadcrumb.Item>{t("安装状态")}</Breadcrumb.Item>
              </Breadcrumb>
              <Row style={{padding: "32px 0 11px 0"}}>
                  <Space>
                      <img src="/images/appstoreIcon.svg" alt="" />
                      <span style={{display: "flex", fontSize: 22, fontWeight: 500, marginTop: -5}}>{t("安装状态")}</span>
                  </Space>
              </Row>
            </div>
            <Spin spinning={loading}>
              <Row style={{ width: "100%" }}>
                <div className="borderBox">
                  <Row className="mb-3" gutter={[20, 10]}>
                    <Col>
                      {t("应用名称")}:
                      <Input
                        placeholder={t("输入应用名称")}
                        value={search}
                        style={{ width: "220px", marginLeft: 10 }}
                        onChange={(e) => this.setState({ search: e.target.value })}
                      ></Input>
                    </Col>
                    <Col>
                      <Button type="primary" onClick={this.onSearch}>
                        {t("查询")}
                      </Button>
                    </Col>
                  </Row>
                </div>
                <div className="borderBox">
                  <Row>
                    {data.length > 0 && (
                      <Table
                        size="middle"
                        style={{width: "100%"}}
                        loading={loading}
                        dataSource={data}
                        pagination={false}
                        // onChange={this.onTableChange}
                        rowKey={record => record.id}
                        columns={tableColumns.map((item)=>{ 
                          item.title = t(item.title)
                          return item 
                        })}
                        // rowSelection={this.rowSelection()}
                        locale={{emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t("暂无数据")}></Empty>}}
                      ></Table>
                    )}
                  </Row>
                  {data.length <= 0 && (
                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t("暂无数据")}></Empty>
                  )}
                  <ConfigProvider locale={i18n.language === "zh" ? zh_CN : en_US}>
                    <Pagination
                      style={{ textAlign: "right", marginTop: "20px" }}
                      pageSize={pageSize}
                      current={pageIndex}
                      total={totalCount}
                      showTotal={(total, range) =>
                        `${range[0]}-${range[1]} / ${total} ${t("条")}`
                      }
                      onChange={(page, pageSize) => {
                        this.setState({ pageIndex: page, pageSize: pageSize ? pageSize : 0 })
                        this.getList(page, pageSize);
                      }}
                      showTitle={false}
                      onShowSizeChange={(current, size) => this.getList(current, size)}
                    ></Pagination>
                  </ConfigProvider>
                </div>
              </Row>
            </Spin>
          </div>
        )
      }}</Translation>
    );
  }
}

export default connect(mapStatetoProps, {})(TemplateAppInstallPage);
